import { Directive, ElementRef, Input } from '@angular/core';
import { SlIdContext } from './sl-id-context';

@Directive({ selector: '[sl-id]' })
export class SlIdDirective {
  constructor(private el: ElementRef, private ids: SlIdContext) {}

  @Input('sl-id')
  set localId(value: string) {
    if (!value) {
      this.el.nativeElement.removeAttribute('id');
      return;
    }
    this.el.nativeElement.setAttribute('id', this.ids.id(value));
    this.el.nativeElement.removeAttribute('sl-id');
  }
}
